module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo06-7086fead3ebfa6974b04404c1d8ba0cc.jpg";